import { motion } from "framer-motion";
import ContactForm from "@/components/ContactForm";
import {
  Globe,
  TrendingUp,
  Search,
  Share2,
  Check,
  Smartphone,
  Zap,
  BarChart3,
  Users,
  FileText,
} from "lucide-react";

const ServicesPage = () => {
  const webFeatures = [
    "Mobil uyumlu responsive tasarım",
    "Hızlı yükleme süreleri",
    "SEO dostu altyapı",
    "İletişim formu entegrasyonu",
    "Google Analytics kurulumu",
    "SSL sertifikası dahil",
  ];

  const adsFeatures = [
    "Hedef kitle analizi",
    "Anahtar kelime optimizasyonu",
    "A/B test kampanyaları",
    "Dönüşüm takibi",
    "Aylık performans raporları",
    "Sürekli optimizasyon",
  ];

  const seoFeatures = [
    "Teknik SEO denetimi",
    "İçerik stratejisi",
    "Backlink çalışması",
    "Yerel SEO optimizasyonu",
    "Rakip analizi",
    "Aylık raporlama",
  ];

  const socialFeatures = [
    "İçerik takvimi oluşturma",
    "Görsel tasarım",
    "Topluluk yönetimi",
    "Reklam kampanyaları",
    "Analitik raporlama",
    "Kriz yönetimi",
  ];

  return (
    <div className="pt-20">
      {/* Hero */}
      <section className="py-24 bg-gradient-to-br from-purple-50 via-white to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center max-w-3xl mx-auto"
          >
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-purple-600 mb-4">
              HİZMETLERİMİZ
            </p>
            <h1 className="text-4xl sm:text-5xl font-black tracking-tighter text-slate-900 font-['Outfit'] mb-6">
              Dijitalde işinizi <span className="text-gradient">büyütecek</span> çözümlerimiz
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed">
              ROI odaklı dijital pazarlama stratejileri ile işletmenizi bir üst seviyeye taşıyoruz.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Web Tasarım */}
      <section className="py-24" id="web-tasarim" data-testid="web-design-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <div className="p-3 rounded-xl bg-purple-50 text-purple-600 inline-block mb-4">
                  <Globe size={32} />
                </div>
                <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 font-['Outfit'] mb-4">
                  Web Sitesi Kurulumu
                </h2>
                <p className="text-lg text-slate-600 leading-relaxed mb-8">
                  Modern, hızlı ve mobil uyumlu web siteleri geliştiriyoruz. Müşterilerinizi 
                  etkileyecek tasarımlar ile dijital varlığınızı güçlendirin.
                </p>

                <div className="grid sm:grid-cols-2 gap-4">
                  {webFeatures.map((feature, index) => (
                    <div key={index} className="flex items-center gap-3">
                      <div className="p-1 rounded-full bg-green-100">
                        <Check size={16} className="text-green-600" />
                      </div>
                      <span className="text-slate-700">{feature}</span>
                    </div>
                  ))}
                </div>

                <div className="mt-8 p-6 bg-slate-50 rounded-2xl">
                  <div className="flex items-center gap-4 mb-4">
                    <Smartphone className="text-purple-600" size={24} />
                    <Zap className="text-purple-600" size={24} />
                    <BarChart3 className="text-purple-600" size={24} />
                  </div>
                  <p className="text-slate-600">
                    <strong>5 iş günü</strong> içinde web siteniz yayında. Hızlı kurulum, 
                    profesyonel sonuç.
                  </p>
                </div>
              </motion.div>
            </div>

            <div className="lg:sticky lg:top-28 lg:self-start">
              <ContactForm variant="compact" title="Teklif Alın" />
            </div>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <hr className="border-slate-100" />
      </div>

      {/* Google Ads */}
      <section className="py-24" id="google-ads" data-testid="google-ads-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <div className="p-3 rounded-xl bg-purple-50 text-purple-600 inline-block mb-4">
                  <TrendingUp size={32} />
                </div>
                <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 font-['Outfit'] mb-4">
                  Google Ads Yönetimi
                </h2>
                <p className="text-lg text-slate-600 leading-relaxed mb-8">
                  ROI odaklı reklam kampanyaları ile doğru müşteriye doğru zamanda ulaşın. 
                  Reklam bütçenizi en verimli şekilde kullanıyoruz.
                </p>

                <div className="grid sm:grid-cols-2 gap-4">
                  {adsFeatures.map((feature, index) => (
                    <div key={index} className="flex items-center gap-3">
                      <div className="p-1 rounded-full bg-green-100">
                        <Check size={16} className="text-green-600" />
                      </div>
                      <span className="text-slate-700">{feature}</span>
                    </div>
                  ))}
                </div>

                <div className="mt-8 p-6 bg-gradient-to-r from-purple-50 to-blue-50 rounded-2xl">
                  <p className="text-slate-700">
                    <strong className="text-purple-600">%100 Şeffaflık:</strong> Reklam 
                    bütçeniz direkt Google'a gider. Her kuruşun nereye harcandığını görürsünüz.
                  </p>
                </div>
              </motion.div>
            </div>

            <div className="lg:sticky lg:top-28 lg:self-start">
              <ContactForm variant="compact" title="Teklif Alın" />
            </div>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <hr className="border-slate-100" />
      </div>

      {/* SEO */}
      <section className="py-24" id="seo" data-testid="seo-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <div className="p-3 rounded-xl bg-purple-50 text-purple-600 inline-block mb-4">
                  <Search size={32} />
                </div>
                <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 font-['Outfit'] mb-4">
                  SEO Optimizasyonu
                </h2>
                <p className="text-lg text-slate-600 leading-relaxed mb-8">
                  Organik arama sonuçlarında üst sıralara çıkın. Uzun vadeli, sürdürülebilir 
                  trafik artışı sağlıyoruz.
                </p>

                <div className="grid sm:grid-cols-2 gap-4">
                  {seoFeatures.map((feature, index) => (
                    <div key={index} className="flex items-center gap-3">
                      <div className="p-1 rounded-full bg-green-100">
                        <Check size={16} className="text-green-600" />
                      </div>
                      <span className="text-slate-700">{feature}</span>
                    </div>
                  ))}
                </div>
              </motion.div>
            </div>

            <div className="lg:sticky lg:top-28 lg:self-start">
              <ContactForm variant="compact" title="Teklif Alın" />
            </div>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <hr className="border-slate-100" />
      </div>

      {/* Sosyal Medya */}
      <section className="py-24" id="sosyal-medya" data-testid="social-media-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <div className="p-3 rounded-xl bg-purple-50 text-purple-600 inline-block mb-4">
                  <Share2 size={32} />
                </div>
                <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 font-['Outfit'] mb-4">
                  Sosyal Medya Yönetimi
                </h2>
                <p className="text-lg text-slate-600 leading-relaxed mb-8">
                  Markanızı sosyal medyada güçlendirin. Doğru platformlarda, doğru içeriklerle 
                  hedef kitlenize ulaşın.
                </p>

                <div className="grid sm:grid-cols-2 gap-4">
                  {socialFeatures.map((feature, index) => (
                    <div key={index} className="flex items-center gap-3">
                      <div className="p-1 rounded-full bg-green-100">
                        <Check size={16} className="text-green-600" />
                      </div>
                      <span className="text-slate-700">{feature}</span>
                    </div>
                  ))}
                </div>
              </motion.div>
            </div>

            <div className="lg:sticky lg:top-28 lg:self-start">
              <ContactForm variant="compact" title="Teklif Alın" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
